/* eslint-disable @typescript-eslint/ban-ts-comment */

import type { Store } from 'mipd';
import { injected } from 'wagmi/connectors';

import type { WalletAdapter } from '../../types';
import { getTargetEIP6963, isProviderExistsEIP6963 } from '../../utils';

import { Icon } from './icon';

export const rainbowId = 'rainbow';
export const rainbowName = 'Rainbow';
export const rainbowRdns = 'me.rainbow';

const dappUrl = globalThis.window ? globalThis.window.location.host + globalThis.window.location.pathname : '';
/** @fallback https://rainbow.me/dapp?url=${deeplinkDAppUrl} */
const deeplink = `rainbow://dapp?url=${dappUrl}`;

const getRainbowConnector = (providersStore: Store) =>
  injected({
    target: () => getTargetEIP6963(providersStore, rainbowRdns),
  });

type Params = {
  providersStore: Store;
};

export const Rainbow: WalletAdapter = ({ providersStore }: Params) => {
  return {
    walletName: rainbowName,
    walletId: rainbowId,
    type: injected.type,
    deeplink,
    Icon,
    detector: () => isProviderExistsEIP6963(providersStore, rainbowRdns),
    getConnector: () => getRainbowConnector(providersStore),
  };
};
